import React from 'react';
import {
  HeaderWrapper,
  ValueWrapper,
  TitleWrapper,
  IconWrap,
  SecondRow,
} from '@components/metrics-panel-hz/MetricCard/styled';
import { Tooltip } from 'antd';
import { useGetDataForMetric } from '@src/components/usage-dashboard/hooks/useMetricSeries';
import { humanize } from '@utils';
import { InfoCircleOutlined } from '@ant-design/icons';
import { usageMetricList } from '@src/components/usage-dashboard/atoms';
import { getUsageMetricsMeta } from '@src/components/usage-dashboard/hooks/utils';

const Header = ({ metric }) => {
  const { data }: any = useGetDataForMetric(metric);
  const { total } = data;
  const usageMetricsMeta = getUsageMetricsMeta();
  const displayTotal = () => {
    const result = humanize(total, usageMetricsMeta[metric].unit);
    if (result === null) {
      return '';
    }
    return `${result} ${usageMetricList[metric].localUnit}`;
  };

  return (
    <HeaderWrapper>
      <TitleWrapper>
        <h4 style={{ marginBottom: 0 }}>
          {usageMetricList[metric].displayName}
          <IconWrap>
            {usageMetricList[metric].tooltipText ? (
              <Tooltip title={usageMetricList[metric].tooltipText}>
                <InfoCircleOutlined />
              </Tooltip>
            ) : (
              ''
            )}
          </IconWrap>
        </h4>
      </TitleWrapper>
      <SecondRow>
        <ValueWrapper>
          <Tooltip title={total ? `${total.toFixed(2)} ${usageMetricList[metric].localUnit}` : ''}>
            {displayTotal()}
          </Tooltip>
        </ValueWrapper>
      </SecondRow>
    </HeaderWrapper>
  );
};

export default Header;
